<template>
    <div class="container-pix">    
        <p class="pix-style mt-3">
            <strong>
               {{ valueTicket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
            </strong>
        </p>
    </div>
</template>
<script>
export default {
    props: {
        valueTicket: {
            type: String,
            default: 0,
        },
    },

}
</script>
<style scoped>

.pix-style {
    text-align: center;
    padding: 10px;
    font-size: 25px;
    color: black;
}
</style>